/**
 * The last-week baseline segment's step ids, in the order they sit in the
 * signup step list. Kept free of imports so the step list can include it
 * without a cycle.
 */
export const BASELINE_STEPS = ['baseline-week', 'baseline-typical', 'baseline-adjust'] as const;

export type BaselineStepId = (typeof BASELINE_STEPS)[number];

/** The last id in the segment; the flow leaves to whatever step follows it. */
export const LAST_BASELINE_STEP: BaselineStepId = 'baseline-adjust';
